import {Component, OnInit} from '@angular/core';
import {Attivita} from '../model/attivita';
import {AttivitaService} from '../service/attivita.service';
import {ContenutoGenericoService} from '../service/contenuto-generico.service';
import {ContenutoGenerico} from '../model/contenuto-generico';
import {AllegatoService} from 'src/app/service/allegato.service';
import {Allegato} from 'src/app/model/allegato';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {MultilinguaService} from '../service/multilingua.service';
import {MenuService} from '../service/menu.service';
import {getAttivita, getOtherLangs} from '../constants/functions';
import {SeoService} from '../service/seo.service';
import {DOCS_REPLACE} from '../constants/constants';

@Component({
    selector: 'app-settori',
    templateUrl: './aree.component.html',
})
export class AreeComponent implements OnInit {
    public component: string = null;

    public attivitas: Array<Attivita>;
    public element: ContenutoGenerico;
    public allegato: Allegato;
    public loading = true;
    lingua: string;


    constructor(
        public allegatoService: AllegatoService,
        private contenutoService: ContenutoGenericoService,
        private multilingueService: MultilinguaService,
        private menuService: MenuService,
        private seoService: SeoService,
        private location: Location,
        public route: ActivatedRoute,
        private attivitaService: AttivitaService) {
    }

    ngOnInit() {
        this.route.url
            .subscribe(() => {
                const url = this.location.path().split('/');
                this.component = url.pop();
                this.contenutoService.find(this.component).subscribe(attivita => {
                        this.element = attivita;
                        this.lingua = this.element.lang;
                        if (this.element && this.element.immagine) {
                            this.allegatoService.find(attivita.immagine).subscribe(allegato => {
                                    if (allegato) {
                                        this.allegato = allegato;
                                        this.allegato.path = DOCS_REPLACE(this.allegato.uuid);
                                        this.seoService.setImage(this.allegato.path);
                                    }
                                    this.loading = false;
                                },
                                err => {
                                    this.loading = false;
                                });
                        }
                        getOtherLangs(this.multilingueService, this.lingua,
                            this.menuService, this.seoService, this.element.uuid);
                        this.attivitas = new Array<Attivita>();

                        const attivitaBoundToThis = getAttivita.bind(this);
                        attivitaBoundToThis();
                    },
                    err => {
                        this.loading = false;
                    });

            });
    }
}
